import React from 'react';
import { Award, ShieldCheck } from 'lucide-react';
import { useI18n } from '../context/I18nContext';

const certData = [
  { code: 'ISO 9001', full: 'Quality Management System', color: '#0b2545' },
  { code: 'BIS', full: 'Bureau of Indian Standards', color: '#7c2d12' },
  { code: 'ASTM', full: 'American Society for Testing & Materials', color: '#4c1d95' },
  { code: 'CE', full: 'Conformité Européenne', color: '#0e7490' }
];

const CertCard = ({ c }) => (
  <div className="group relative bg-white border border-slate-200 hover:border-[#f7a11a] hover:shadow-xl transition-all overflow-hidden">
    <div className="absolute inset-x-0 top-0 h-2" style={{ background: c.color }} />
    <div className="p-6 pt-8">
      <div className="flex items-start justify-between">
        <div className="w-14 h-14 flex items-center justify-center" style={{ background: c.color }}>
          <Award className="w-7 h-7 text-white" />
        </div>
        <ShieldCheck className="w-5 h-5 text-[#f7a11a]" />
      </div>
      <div className="mt-6">
        <div className="text-2xl font-black tracking-tight text-slate-900">{c.code}</div>
        <div className="mt-1 text-sm text-slate-600 leading-snug">{c.full}</div>
      </div>
    </div>
  </div>
);

const Certifications = () => {
  const { t } = useI18n();

  return (
    <section id="certifications" className="py-24 lg:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <span className="text-xs tracking-[0.3em] uppercase text-[#f7a11a] font-semibold">{t('certs.eyebrow')}</span>
          <h2 className="mt-4 text-4xl lg:text-5xl font-black text-slate-900 leading-tight tracking-tight">
            {t('certs.title')} <span className="text-slate-400">{t('certs.title2')}</span>
          </h2>
          <p className="mt-6 text-slate-600 leading-relaxed">{t('certs.desc')}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {certData.map((c) => (
            <CertCard key={c.code} c={c} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
